import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const ADD_CASE_MANULLY = "ADD_CASE_MANULLY";

export const service = async (caseToAdd) => {
  const options: object = {
    url: "/api/EaCaseApiController/addCaseManually",
    method: "POST",
    body: JSON.stringify(caseToAdd),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(ADD_CASE_MANULLY, service, mock);
